import React from 'react';
import styles from './style/typography_style.module.scss';
import PropTypes from 'prop-types';
import Foundation, { FOUNDATION_PROPTYPES } from '../Foundation'

const Typography = ({ typeface, decoration, children, wrap, className='', style = {}, ...props }) => {
    return (
        <Foundation {...props}>
            <span className={`${className && className} ${styles.typography} ${styles[typeface]} ${decoration && styles[decoration]} ${wrap && styles[wrap]}`}
                  style={style}
            >
                {children}
            </span>
        </Foundation>
    );
};

Typography.propTypes = {
    ...FOUNDATION_PROPTYPES,
    typeface: PropTypes.oneOf([
        'title-xl-light',
        'title-l-light',
        'title-l-regular',
        'title-l-medium',
        'title-m-light',
        'title-m-medium',
        'title-s-light',
        'title-s-regular',
        'title-s-medium',
        'title-s-bold',
        'title-xs-light',
        'title-xxs-medium',
        'body-m-light',
        'body-m-regular',
        'body-m-medium',
        'body-s-regular',
        'body-s-light',
        'body-xs-regular',
        'body-xs-light',
        'body-xs-bold'
    ]).isRequired,
    decoration: PropTypes.oneOf([
        'underline',
        'line-through',
    ]),
    wrap: PropTypes.bool,
    className: PropTypes.string
};

export default Typography;
